import { ref, onMounted } from 'vue'
import { storefrontFetch } from '@/js/utils/storefront'
import { useProduct } from '@/js/composables/product'
import { useCart } from '@/js/composables/cart'
import { groupProductsQuery } from '../utils/data'

export default {
  props: {
    product: {
      type: Object,
      required: true
    }
  },

  setup (props) {
    const {
      currentVariant,
      quantity,
      productOptions,
      selectedOptions,
      baseUrl,
      isSale,
      updateVariant
    } = useProduct(props.product)

    const {
      isLoading: isCartLoading,
      isAddingToCart,
      error: cartError,
      addToCart
    } = useCart()

    const swatchProducts = ref([])

    onMounted(async () => {
      const groupEl = document.querySelector('.color_swatch')
      if (!groupEl) return
      const group = groupEl.dataset.group
      if (!group) return

      let cursor = null
      const allProducts = []

      do {
        const data = await storefrontFetch(groupProductsQuery, {
          cursor,
          groupTag: `tag:'${group}'`
        })
        // console.log('groupProductsQuery data', data)

        if (!data || !data.products) break

        const edges = data.products.edges
        allProducts.push(...edges.map(e => e.node))

        cursor = data.products.pageInfo.hasNextPage
          ? data.products.pageInfo.endCursor
          : null
      } while (cursor)

      // Filter for exact tag matches only
      const filteredProducts = allProducts.filter(product =>
        product.tags.some(tag => tag === group)
      )

      swatchProducts.value = filteredProducts
    })

    const openVTO = (sku, swatchProds) => {
      if (window.openVTO) {
        window.openVTO(sku, swatchProds)
      }
    }

    return {
      currentVariant,
      quantity,
      productOptions,
      selectedOptions,
      baseUrl,
      isSale,
      updateVariant,
      isCartLoading,
      isAddingToCart,
      cartError,
      addToCart,
      swatchProducts,
      openVTO
    }
  },

  data () {
    return {
      currentSlide: 0,
      slider: null,
      nav: null
    }
  },

  mounted () {
    console.log('product-detail mounted')
    // if the URL has variant query string, select that variant
    const queryStringValues = new URLSearchParams(window.location.search)
    if (queryStringValues.has('variant')) {
      this.currentVariant = this.product.variants.find(variant => `${variant.id}` === queryStringValues.get('variant'))
    } else if (this.product.variants.length === 1) {
      this.currentVariant = this.product.variants[0]
    }

    this.initProductSlider()
    this._handleWindowLoad = () => this.handleWindowLoad()
    window.addEventListener('load', this._handleWindowLoad)
  },

  beforeDestroy () {
    if (this._handleWindowLoad) {
      window.removeEventListener('load', this._handleWindowLoad)
    }
    this.teardownProductSlider()
  },

  watch: {
    // currentVariant (value) {
    //   if (!value) {
    //     removeParameterFromUrl('variant')
    //     return
    //   }

    //   if (value.featured_image && this.product.images.length > 1) {
    //     this.slider?.moveToIdx(value.featured_image.position - 1)
    //   }

    //   const url = getUrlWithVariant(window.location.href, value.id)
    //   window.history.replaceState({ path: url }, '', url)
    // }
  },

  methods: {
    autoplayVideoWithRetry (videoEl) {
      if (!videoEl) return
      videoEl.muted = true
      videoEl.defaultMuted = true
      videoEl.setAttribute('muted', 'muted')
      videoEl.setAttribute('playsinline', 'playsinline')
      videoEl.setAttribute('webkit-playsinline', 'webkit-playsinline')
      videoEl.setAttribute('autoplay', 'autoplay')

      let tries = 0
      const maxTries = 8
      const timer = setInterval(() => {
        tries += 1
        const p = videoEl.play()
        if (p && typeof p.then === 'function') {
          p.then(() => {
            clearInterval(timer)
          }).catch(() => {
            if (tries >= maxTries) clearInterval(timer)
          })
        } else if (tries >= maxTries) {
          clearInterval(timer)
        }
      }, 150)
    },

    mountVideoForSlide ($slide) {
      if (!$slide || !$slide.length) return
      const $videoBlock = $slide.find('.pdp-video-slide')
      if (!$videoBlock.length) return
      const $container = $videoBlock.find('.pdp-video-container')
      if (!$container.length || $container.children().length) return
      const $trigger = $videoBlock.find('.pdp-video-trigger')
      const aspectRatio = parseFloat($videoBlock.data('aspect-ratio')) || 1

      const kind = $videoBlock.data('video-kind')
      const src = $videoBlock.data('video-src')
      if (!src) return

      $videoBlock.css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%'
      })

      $container.css({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: '#000'
      })

      if (kind === 'external') {
        const iframe = window.jQuery('<iframe>', {
          src,
          allow: 'autoplay; encrypted-media; picture-in-picture',
          allowfullscreen: 'allowfullscreen',
          frameborder: '0',
          loading: 'lazy',
          title: 'Product video'
        }).css({
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          maxHeight: '100%',
          aspectRatio: String(aspectRatio),
          pointerEvents: 'none'
        })
        $container.append(iframe)
        $trigger.css({
          opacity: 0,
          visibility: 'hidden',
          pointerEvents: 'none',
          transition: 'opacity .2s ease'
        })
      } else {
        const poster = $videoBlock.data('poster-src')
        const $video = window.jQuery('<video>', {
          controls: false,
          playsinline: true,
          muted: true,
          autoplay: true,
          loop: true,
          preload: 'none',
          src
        }).css({
          width: '100%',
          height: '100%',
          maxWidth: '100%',
          maxHeight: '100%',
          objectFit: 'cover',
          objectPosition: 'center center',
          display: 'block',
          pointerEvents: 'none'
        })

        $video.removeAttr('controls')
        if (poster) $video.attr('poster', poster)
        $container.append($video)
        const videoEl = $video.get(0)
        if (videoEl) {
          videoEl.controls = false
          videoEl.addEventListener('click', function (e) {
            e.preventDefault()
            e.stopPropagation()
          })
          videoEl.addEventListener('loadeddata', function () {
            $trigger.css({
              opacity: 0,
              visibility: 'hidden',
              pointerEvents: 'none',
              transition: 'opacity .2s ease'
            })
          }, { once: true })
        }

        this.autoplayVideoWithRetry(videoEl)
      }

      $videoBlock.addClass('is-loaded')
      if (kind === 'shopify') {
        $trigger.css({
          opacity: 1,
          visibility: 'visible',
          pointerEvents: 'none'
        })
      }
    },

    syncZoomForActiveSlide () {
      const $activeSlide = window.jQuery('.productSlider .slide.slick-current')
      if (!$activeSlide.length) return
      const mediaType = $activeSlide.attr('data-media-type')
      const isVideo = mediaType === 'video' || mediaType === 'external_video'
      const $proBoxImage = window.jQuery('.proBoxImage')
      const $zoomElements = $proBoxImage.find('.zoomContainer, .zoomLens, .zoomWindowContainer, .zoomWindow')

      $proBoxImage.toggleClass('no-zoom-on-video', isVideo)
      if (isVideo) {
        $zoomElements.hide()
      } else {
        $zoomElements.show()
      }
    },

    mountCurrentSlideVideo () {
      const $currentSlide = window.jQuery('.productSlider .slide.slick-current')
      if ($currentSlide.length) {
        this.mountVideoForSlide($currentSlide)
        $currentSlide.find('video').each((_, videoEl) => {
          this.autoplayVideoWithRetry(videoEl)
        })
      }
    },

    initProductSlider () {
      if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.slick) return
      const $productSlider = window.jQuery('.productSlider')
      if (!$productSlider.length || $productSlider.hasClass('slick-initialized')) return

      $productSlider.on('init.pdpVideo', (event, slick) => {
        // mount ALL video slides immediately so GPU layers are pre-created before any swipe
        window.jQuery(slick.$slides).each((index, slide) => {
          this.mountVideoForSlide(window.jQuery(slide))
          if (index !== (slick.currentSlide || 0)) {
            window.jQuery(slide).find('video').each((_, videoEl) => {
              videoEl.pause()
            })
          }
        })
        this.syncZoomForActiveSlide()
        setTimeout(() => {
          this.mountCurrentSlideVideo()
        }, 0)
      })

      $productSlider.slick({
        infinite: false,
        dots: true,
        arrows: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: function (slick, index) {
          const $slide = window.jQuery(slick.$slides[index])
          const image = $slide.attr('data-thumb') || $slide.find('img').first().attr('src')
          return '<div data-role="none" data-slick-index="' + index + '"><img class="lazyload" src="' + image + '" /></div>'
        }
      }).on('afterChange.pdpVideo', (event, slick, currentSlide) => {
        window.productImageLightboxGoToSlide = currentSlide
        this.syncZoomForActiveSlide()
        window.jQuery(slick.$slides).each((index, slide) => {
          if (index === currentSlide) {
            window.jQuery(slide).find('video').each((_, videoEl) => {
              this.autoplayVideoWithRetry(videoEl)
            })
          } else {
            // pause non-active video slides; never destroy elements to avoid GPU layer recreation
            window.jQuery(slide).find('video').each((_, videoEl) => {
              videoEl.pause()
            })
          }
        })
      })

      window.jQuery('body').on('click.pdpVideo', '.pdp-video-trigger', (event) => {
        const $videoSlide = window.jQuery(event.currentTarget).closest('.pdp-video-slide')
        if (!$videoSlide.length) return
        this.mountVideoForSlide($videoSlide.closest('.slide'))
      })
    },

    teardownProductSlider () {
      if (!window.jQuery) return
      window.jQuery('body').off('click.pdpVideo')
      const $productSlider = window.jQuery('.productSlider')
      $productSlider.off('.pdpVideo')
    },

    handleWindowLoad () {
      this.syncZoomForActiveSlide()
      this.mountCurrentSlideVideo()
    },

    async handleAddToCart () {
      const cartData = await this.addToCart(this.currentVariant.id, this.quantity)
      // const { success } = await this.addToCart(this.currentVariant.id, this.quantity)
      // if (success) this.toggleFlyout('minicart')
      const cartDrawer = document.getElementById('cartDrawer')

      window.ajaxCart.refreshCart(cartData)
      window.ajaxCart.refreshCartCount(cartData)
      cartDrawer.classList.add('show')

      setTimeout(function () {
        cartDrawer.classList.remove('show')
      }, 6000)
    },

    setQuantity (amount) {
      console.log('setQuantity', amount)
      this.quantity = amount
      this.closeMobileQuantitySelector()
    },

    // START coppying js from existing codes
    openMobileQuantitySelector () {
      document.querySelector('.mobile-quantity-dropdown').style.display = 'block'
      setTimeout(() => {
        document.querySelector('.mobile-quantity-dropdown').classList.add('open')
      }, 100)
      document.body.classList.add('overflow-hidden')
    },

    closeMobileQuantitySelector () {
      setTimeout(() => {
        document.querySelector('.mobile-quantity-dropdown').style.display = 'none'
      }, 300)
      document.querySelector('.mobile-quantity-dropdown').classList.remove('open')
      document.body.classList.remove('overflow-hidden')
    },

    openMobileSiblingSelector () {
      document.querySelector('.mobile-siblings-dropdown').style.display = 'block'
      setTimeout(() => {
        document.querySelector('.mobile-siblings-dropdown').classList.add('open')
      }, 100)
      document.body.classList.add('overflow-hidden')
    },

    closeMobileSiblingSelector () {
      setTimeout(() => {
        document.querySelector('.mobile-siblings-dropdown').style.display = 'none'
      }, 300)
      document.querySelector('.mobile-siblings-dropdown').classList.remove('open')
      document.body.classList.remove('overflow-hidden')
    },

    getFrameColour (tags) {
      if (!tags) return ''
      const colourTag = tags.find(tag =>
        tag.toLowerCase().includes('frame colour:') ||
        tag.toLowerCase().includes('frame color:')
      )
      return colourTag ? colourTag.split(':').pop().trim() : ''
    },

    showGlobalFit () {
      const accordionItems = document.querySelectorAll('.proDetailInfo .velaPanel')
      accordionItems.forEach(item => {
        item.querySelector('.panel-collapse').classList.add('collapse')
        item.querySelector('.panel-collapse').classList.remove('in')
        item.querySelector('.panel-heading a').classList.add('collapsed')
      })

      const globalFitItem = document.getElementById('proCollapseGlobalFit')
      globalFitItem.classList.add('in')
      globalFitItem.style.height = 'auto'

      // Get the element's position and scroll with offset
      const globalFitInfo = document.getElementById('global-fit-info')
      globalFitInfo.querySelector('.panel-heading a').classList.remove('collapsed')
      let elementPosition = globalFitInfo.getBoundingClientRect().top + window.pageYOffset
      const headerBar = document.getElementById('Header--Main')
      if (headerBar) {
        elementPosition = elementPosition - headerBar.offsetHeight
      }

      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      })
    },

    handleSelectFrame (element, sku) {
      window.selectFrame(element, sku)
    }
  }
}
